module.exports = __webpack_public_path__ + "img/user-black.155e7a96.svg";